// Module
var code = `<div id="reportModal" class="modal hide fade" tabindex="-1" role="dialog" aria-labelledby="reportModalLabel" aria-hidden="true">
  <div class="modal-header">
    <h2 id="modalHeader">Print</h2>
  </div>
  <div class="modal-body">
    <report-view report-content="\$ctrl.reportContent" lazy-display="false"></report-view>
  </div>
  <div class="modal-footer">
    <button id="modalPrint" class="btn btn-print"
            ng-click="\$ctrl.print()">Print</button>
    <button id="modalDownload" class="btn btn-primary" ng-if="!\$ctrl.hideXls"
            ng-click="\$ctrl.downloadXls()">Download XLS</button>
    <button id="modalClose" class="btn btn" data-dismiss="modal" aria-hidden="true"
            ng-click="\$ctrl.close()">Exit</button>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/modal/report-modal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;